<template>
    <v-row class="white-card px-3">
        <v-col cols="12">
            <v-img class="mx-auto" width="69" contain :src="imgLogo"/>
        </v-col>
        <v-col cols="12" class="headline-heavy text-center">
            Tus conexiones
        </v-col>
        <v-col cols="12" class="subtitle-profile">
            Aquí se mostrarán las instituciones en las que ya hayas realizado una Orden de Examenes previamente
        </v-col>
        <v-col cols="12">
            <kimsa-combobox
                label="Seleccionar conexión"
                @change="entity = $event"
                :value="entity"
                :items="entityOptions"
                outlined dense
            />
        </v-col>
        <v-col cols="12" class="text-center my-5">
            <v-btn color="secondary" x-large depressed class="normal-btn" :disabled="disabled" @click="onContinue">
                Continuar
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import httpService from "@/services/httpService";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import {ROLES} from "@/utils/Constants";

export default {
    name: "ClientEntitySelector",
    components: {KimsaCombobox},
    data() {
        return {
            loading: false,
            entity: null,
            entityOptions: []
        }
    },
    async mounted() {
        const vm = this
        await vm.loadMyEntities()
    },
    computed: {
        disabled(vm = this) {
            return !vm.entity
        }
    },
    methods: {
        async loadMyEntities() {
            const vm = this
            vm.loading = true
            let response = await httpService.get(`users/${vm.currentUser.id}/my-entities`)
            console.log('response loadMyEntities', response)
            vm.entityOptions = response.data.entities.map(entity => ({
                ...entity,
                id: entity.id,
                name: `${entity.name} (${entity.role_id === ROLES.LABORATORY ? 'Laboratorio' : 'Empresa'})`,
            }))
            vm.loading = false
        },
        async onContinue() {
            const vm = this
            vm.$emit('success', vm.entity)
        },
    },
}
</script>

<style scoped>

.subtitle-profile {
    font-size: 14px;
    line-height: 16px;
    color: #939BB3;
}

</style>